export default {
    common: {
        title: 'Sisältötekoäly',
        socialPlanner: 'Sosiaalinen suunnittelija',
        blog: 'Blogi',
        funnel: 'Suppilo',
        website: 'Verkkosivusto',
        mediaLibrary: 'Mediakirjasto',
        email: 'Sähköposti',
        words: 'Sanat',
        variations: 'Variaatiot',
        thisIsPaidService: 'Tämä ominaisuus on maksullinen palvelu, ja siitä aiheutuu maksuja käyttösi perusteella',
        all: 'Kaikki',
    },
};
